import { ActivityPicker, Field, PhoneField, SectionTitle, TextField } from "./KycFields";

/**
 * An individual's verification — the highlighted part of Keepz's form: full name,
 * personal number, business activity, email and phone. What a business registered to
 * a private person fills in. Changes are reported as (path, value).
 */
export default function KycForm({ form, onChange, errors = {}, disabled, isDark, t }) {
  return (
    <div className="space-y-5">
      <section>
        <SectionTitle
          title={t("kyc.sections.individual")}
          hint={t("kyc.sections.individualHint")}
          isDark={isDark}
        />
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <Field label={t("kyc.fields.fullName")} required error={errors.fullName} isDark={isDark} t={t} htmlFor="kyc-fullName">
            <TextField
              id="kyc-fullName"
              value={form.fullName}
              onChange={(v) => onChange("fullName", v)}
              error={errors.fullName}
              isDark={isDark}
              disabled={disabled}
              maxLength={200}
              autoComplete="name"
              placeholder={t("kyc.placeholders.fullName")}
            />
          </Field>
          <Field
            label={t("kyc.fields.personalId")}
            hint={t("kyc.fields.personalIdHint")}
            required
            error={errors.personalId}
            isDark={isDark}
            t={t}
            htmlFor="kyc-personalId"
          >
            <TextField
              id="kyc-personalId"
              value={form.personalId}
              onChange={(v) => onChange("personalId", v.toUpperCase())}
              error={errors.personalId}
              isDark={isDark}
              disabled={disabled}
              maxLength={20}
              autoComplete="off"
              placeholder={t("kyc.placeholders.personalId")}
            />
          </Field>
          <Field label={t("kyc.fields.email")} required error={errors.email} isDark={isDark} t={t} htmlFor="kyc-email">
            <TextField
              id="kyc-email"
              inputMode="email"
              value={form.email}
              onChange={(v) => onChange("email", v)}
              error={errors.email}
              isDark={isDark}
              disabled={disabled}
              maxLength={200}
              autoComplete="email"
              placeholder={t("kyc.placeholders.email")}
            />
          </Field>
          <Field label={t("kyc.fields.phone")} required error={errors.phone} isDark={isDark} t={t}>
            <PhoneField
              id="kyc-phone"
              value={form.phone}
              onChange={(v) => onChange("phone", v)}
              error={errors.phone}
              disabled={disabled}
              isDark={isDark}
            />
          </Field>
        </div>
      </section>

      <section>
        <SectionTitle title={t("kyc.sections.individualActivity")} isDark={isDark} />
        <ActivityPicker
          value={form.businessActivities}
          other={form.businessActivityOther}
          onChange={(v) => onChange("businessActivities", v)}
          onOtherChange={(v) => onChange("businessActivityOther", v)}
          error={errors.businessActivities}
          otherError={errors.businessActivityOther}
          disabled={disabled}
          isDark={isDark}
          t={t}
        />
      </section>
    </div>
  );
}
